import { Grid, Loader } from "@aws-amplify/ui-react";
import { CCard } from "@coreui/react";
import { API, graphqlOperation } from "aws-amplify";
import { useEffect, useState } from "react";
import LocalizedStrings from "react-localization";

import { getCompany } from "graphql/queries";

const CompanyCard = ({ companyID }) => {
  const [companyState, setCompanyState] = useState({});
  const [loading, setLoading] = useState(false);

  async function fetchCompany(id) {
    try {
      setLoading(true);
      const companyData = await API.graphql(
        graphqlOperation(getCompany, {
          id,
        })
      );
      const companyItem = companyData.data.getCompany;
      setCompanyState(companyItem);
    } catch (err) {
      console.log("Error fetchCompany", err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchCompany(companyID);
  }, [companyID]);

  return (
    <CCard
      className="p-3"
      borderRadius="medium"
      variation="outlined"
      style={{ height: "100%" }}
    >
      {loading ? (
        <Loader />
      ) : (
        <Grid gap="5px">
          {companyState.name && (
            <div>
              <span>{strings.companyDetails.company}: </span>
              <span className="text-muted">{companyState.name}</span>
            </div>
          )}
          {companyState.address && (
            <div>
              <span>{strings.companyDetails.address}: </span>
              <span className="text-muted">{companyState.address}</span>
            </div>
          )}
          {companyState.phone && (
            <div>
              <span>{strings.companyDetails.phone}: </span>
              <span className="text-muted">{companyState.phone}</span>
            </div>
          )}
          {companyState.otherContacts?.length > 0 && (
            <div>
              <span>{strings.companyDetails.contacts}: </span>
              <ul className="mb-0">
                {companyState.otherContacts?.map((contact) => (
                  <li>
                    <span className="text-muted">{contact}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </Grid>
      )}
    </CCard>
  );
};

const strings = new LocalizedStrings({
  es: {
    companyDetails: {
      company: "Empresa",
      address: "Dirección",
      phone: "Teléfono",
      contacts: "Contactos",
    },
  },
});

export default CompanyCard;
